import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showLoginPopupAction } from './store/actions';

export const useLoginPopup = () => {
    const dispatch = useDispatch();

    return useCallback(
        (popupData = {}) => dispatch(showLoginPopupAction(popupData)),
        [dispatch]
    );
};
